import { render } from "./pay-qrcode.vue?vue&type=template&id=207532d7&scoped=true&ts=true"
import script from "./pay-qrcode.vue?vue&type=script&lang=ts"
export * from "./pay-qrcode.vue?vue&type=script&lang=ts"

import "./pay-qrcode.vue?vue&type=style&index=0&id=207532d7&scoped=true&lang=scss&scope=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207532d7"]])